/**
 * Integer percent arithmetic: the rules' one rounding. Every price, cut, tax, rally and levy in
 * the core takes a whole-number percent of a whole number and rounds down through `percentOf`,
 * so the rounding is one rule and a reader finds it in one place. Valor (V1) is the one value
 * that is not whole: its deeds are halves at most (a squad's hex earns 1.5), and a half times a
 * whole percent is exact in binary, so a death's share of it rounds down as exactly.
 */

/** `percent` percent of `value`, rounded down: `Math.floor(value * percent / 100)`. */
export function percentOf(value: number, percent: number): number {
  return Math.floor((value * percent) / 100);
}
